<template>
    <veui-dialog
        :open="isShow"
        :footless="true"
        :closable="false"
        :outside-closable="true"
        ui="auto"
        overlay-class="agent-dialog"
        @cancel="clickCloseBtn"
    >
        <div class="content"></div>
        <div class="foot">
            <div class="btn-container">
                <div
                    class="cancel-btn"
                    @click="clickCloseBtn"
                >
                    <div class="text">暂不开启</div>
                </div>
                <div
                    class="confirm-btn"
                    @click="clickOpenBtn"
                >
                    <div class="text">一键开启</div>
                </div>
            </div>
            <div class="xieyi">点击开启即同意
                <div class="xieyi-container">
                    <span class="click" @click="clickProtocol('agent')">《法行宝律师智能体入驻服务协议》</span>
                    <span class="click" @click="clickProtocol('virtual')">《法行宝虚拟号电话咨询服务协议》</span>
                </div>
            </div>
        </div>
    </veui-dialog>
</template>

<script>
import {Dialog} from 'veui';
import {mapActions} from 'vuex';
export default {
    components: {
        'veui-dialog': Dialog
    },
    data() {
        return {
            isSubmitting: false,
            isShow: true
        };
    },
    methods: {
        ...mapActions({
            getAgentData: 'lawStore/getAgentData'
        }),
        // 点击开启智能体按钮
        clickOpenBtn() {
            this.$wywLog.send({
                serverId: 19291,
                area: 'agent-dialog-open',
                action: 'click'
            });
            if (this.isSubmitting) {
                return;
            }
            this.isSubmitting = true;
            // 请求接口
            this.$http.post('/bp/api/lawyeragent/createbyuid')
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$toast.success('已为您成功提交智能体创建申请，申请结果将由短信方式通知您～');
                        // 刷新智能体信息
                        this.getAgentData();
                        this.isShow = false;
                        return;
                    }
                    if (res && +res.code === 12009) {
                        this.$toast.error(res && res.msg || '律师智能体已存在');
                        // 刷新智能体信息
                        this.getAgentData();
                        this.isShow = false;
                        return;
                    }
                    this.$toast.error(res && res.msg || '提交失败，请稍后再试～');
                })
                .catch(() => {
                    this.$toast.error('提交失败，请稍后再试～');
                })
                .finally(() => {
                    this.isSubmitting = false;
                    this.isShow = false;
                });
        },
        // 点击协议
        clickProtocol(type) {
            if (type === 'agent') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/agent-rule.pdf');
            }
            else if (type === 'virtual') {
                window.open('https://lvlin-fe-saas.cdn.bcebos.com/virtual_number_rule.pdf');
            }
            else {
                window.open('https://youjia-image.cdn.bcebos.com/pdf/law-smartapp/160705507337529aaa5c.pdf');
            }
        },
        // 关闭弹窗
        clickCloseBtn() {
            this.$wywLog.send({
                serverId: 19291,
                area: 'agent-dialog-close',
                action: 'click'
            });
            this.isShow = false;
        }
    },
    watch: {
        isShow(val) {
            if (!val) {
                // 弹窗关闭后抛出变量，让其他弹窗无法打开
                this.$emit('close');
            }
        }
    }
};
</script>

<style lang="less" scoped>
.agent-dialog {
    /deep/.veui-dialog-content {
        border-radius: 8px;
        width: 490px;
        box-shadow: 0 0 10px 0 #c4c4c480;
        background-color: #fff;
        padding: 0;

        .veui-dialog-content-head {
            padding: 0;
        }

        .veui-dialog-content-body {
            padding: 30px;
            margin: 0;
            display: flex;
            flex-direction: column;
            align-items: center;

            .content {
                width: 430px;
                height: 215px;
                border-radius: 6px;
                background: url("https://lvlin-fe-saas.cdn.bcebos.com/assets/agent-create-dialog-ai.png") no-repeat center center/ 100% 100%;
            }

            .foot {
                margin-top: 24px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .btn-container {
                    display: flex;
                    height: 36px;
                    align-items: center;

                    .cancel-btn {
                        width: 104px;
                        height: 36px;
                        border-radius: 6px;
                        background-color: #fff;
                        border: 1px solid #e9ecf3;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;

                        .text {
                            font-family: PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 14px;
                            letter-spacing: 0;
                            color: #1e1f24;
                        }
                    }

                    .cancel-btn:hover {
                        background-color: #f5f5f5;
                    }

                    .confirm-btn {
                        width: 104px;
                        height: 36px;
                        border-radius: 4px;
                        background-color: #05f;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        cursor: pointer;
                        margin-left: 24px;

                        .text {
                            font-family: PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 19.6px;
                            letter-spacing: 0;
                            text-align: center;
                            color: #fff;
                        }
                    }

                    .confirm-btn:hover {
                        background-color: #06f;
                    }
                }

                .xieyi {
                    margin-top: 12px;
                    height: 16px;
                    width: auto;
                    font-family: PingFang SC;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 16px;
                    letter-spacing: 0;
                    color: #848691;
                    display: flex;

                    .xieyi-container {
                        display: flex;
                        flex-direction: column;

                        .click {
                            cursor: pointer;
                            margin-bottom: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>